import React from "react";

function WorkflowTab({ workflows, dataFormato }) {
  const workflowsArray = Array.isArray(workflows) ? workflows : [workflows];
  console.log(workflowsArray)

  return (
    <div className="tab-pane fade" id="quinta-aba" role="tabpanel">
      <table className="table table-striped table-bordered mt-10">
        <thead>
          <tr>
            <th>DATA</th>
            <th>RESPONSÁVEL</th>
            <th>STATUS</th>
          </tr>
        </thead>
        <tbody>
          {workflowsArray.map((workflow) => (
            <tr key={workflow.id}>
              <td>{dataFormato(workflow.data)}</td>
              <td>{workflow.responsavel}</td>
              <td>{workflow.status}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default WorkflowTab;
